import { useHistory, useParams } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useCurrentSpaceContext } from "@circle-react/contexts";
import { userIsAdminOrModeratorOfSpace } from "@circle-react/helpers/spaceHelpers";
import { coursePaths, spaces } from "@circle-react/helpers/urlHelpers";
import { Typography } from "@circle-react-uikit/Typography";

export const LessonHelloBar = () => {
  const { data: space } = useCurrentSpaceContext();
  const isAdmin = userIsAdminOrModeratorOfSpace(space);

  const history = useHistory();
  const params = useParams();
  const goToDashboard = () =>
    history.push(spaces.show({ spaceSlug: params.spaceSlug }));

  if (!isAdmin) {
    return null;
  }

  const editLesson = () => {
    const { sectionId, lessonId } = params;
    history.push(
      coursePaths.editLesson({
        spaceSlug: space.slug,
        sectionId,
        lessonId,
      }),
    );
  };
  return (
    <div
      id="lesson-hello-bar"
      className="bg-dark-primary-button grid-in-hellobar p-2 text-center md:p-3"
    >
      <Typography.LabelSm weight="medium" color="text-badge">
        {t("courses.preview_hellobar")}{" "}
        <button
          type="button"
          onClick={() => {
            editLesson();
          }}
          className="border-b"
        >
          <Typography.LabelSm weight="medium" color="text-badge">
            {t("courses.edit_this_lesson")}
          </Typography.LabelSm>
        </button>{" "}
        {t("courses.or_go")}{" "}
        <button type="button" onClick={goToDashboard} className="border-b">
          <Typography.LabelSm weight="medium" color="text-badge">
            {t("courses.back_to_course_dashboard")}
          </Typography.LabelSm>
        </button>
      </Typography.LabelSm>
    </div>
  );
};
